module.exports = __webpack_public_path__ + "img/img34.eda128be.svg";